export const DEFAULT_META_DESCRIPTION =
  'Mobilisez vos salariés et motivez les à utiliser le vélo grâce aux animations challenges vélo !';
export const DEFAULT_META_IMAGE = '%PUBLIC_URL%/image.png';
